import type { IErrorInfo } from '../errors';
import { errorInfoSchema } from '../errors';
import { objectSchemaOf } from '../helpers';
import Joi from 'joi';

export interface ILogErrorParams {
  error: IErrorInfo;
  source: string;
  version: string;
}

export const logErrorParamsSchema = objectSchemaOf<ILogErrorParams>({
  error: errorInfoSchema.required(),
  source: Joi.string().required(),
  version: Joi.string().required(),
});

export interface IApi {
  appsLogError(params: ILogErrorParams): Promise<void>;
}
